import { graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import Footer from '../../../components/Footer';
import ArrowLongLeft from '../../../components/Global/ArrowLongLeft';
import ArrowRight from '../../../components/Global/ArrowRight';
import ExternalLink from '../../../components/Link/ExternalLink';
import Metadata from '../../../components/Metadata';
import { PartnershipsHeader } from '../../../components/Partnerships';
import SuperscriptCarousel from '../../../components/Partnerships/Superscript/SuperscriptCarousel';
import SuperscriptVideo from '../../../components/Partnerships/Superscript/SuperscriptVideo';
import { COLORS } from '../../../constants/colors';
import SuperscriptData from '../../../data/partnerships/superscript';

const SuperscriptTianahHodding = ({ data }) => {
  const content = SuperscriptData();

  return (
    <div className="partnerships-base partnerships-superscript">
      <Metadata data={content.SUPERSCRIPT.tianah.metadata} host="local" />
      <PartnershipsHeader
        colors={{
          backButton: COLORS.licorice,
          backButtonBackground: COLORS.transparent,
          hamburger: COLORS.licorice,
          hamburgerBackground: COLORS.transparent,
          main: COLORS.licorice,
        }}
      />
      <div>
        <GatsbyImage
          alt={`4 different shots of ${content.SUPERSCRIPT.tianah.name}`}
          image={data.TianahHoddingHeader.childImageSharp.gatsbyImageData}
        />

        <section className="superscript-profile-intro superscript-margin-bottom">
          <div className="superscript-container">
            <div className="superscript-small-container">
              <h1 className="superscript-margin-bottom--small superscript-profile-name">
                {content.SUPERSCRIPT.tianah.name}
              </h1>
              <div className="superscript-profile-video superscript-margin-bottom--small">
                <SuperscriptVideo
                  videoSrcURL="https://www.youtube.com/embed/AfPL9GXCoPY?rel=0"
                  videoTitle="Official Music Video on YouTube"
                />
              </div>
              <div className="superscript-profile-bio">
                {content.SUPERSCRIPT.tianah.bio}
              </div>
            </div>
          </div>
        </section>

        <section className="superscript-container superscript-margin-bottom">
          <div className="superscript-profile-star">
            <img
              alt="Superscript star symbol"
              src={data.SuperscriptStar.publicURL}
            />
          </div>
          <div className="superscript-section-1">
            <div className="superscript-section-1__text">
              <h3 className="superscript-margin-bottom--tiny">
                {content.SUPERSCRIPT.tianah.section1.header}
              </h3>
              <div>{content.SUPERSCRIPT.tianah.section1.text}</div>
            </div>
          </div>
        </section>

        <section className="superscript-profile-pullquote superscript-margin-bottom">
          <div className="superscript-container">
            <div className="superscript-small-container">
              <span className="superscript-profile-pullquote__quote--left">
                <img alt="Left quotation icon" src={data.QuoteLeft.publicURL} />
              </span>
              <div className="superscript-profile-pullquote__text">
                {content.SUPERSCRIPT.tianah.pullquote}
              </div>
              <span className="superscript-profile-pullquote__quote--right">
                <img
                  alt="Right quotation icon"
                  src={data.QuoteRight.publicURL}
                />
              </span>
            </div>
          </div>
        </section>

        <section className="superscript-container superscript-margin-bottom">
          <div className="superscript-profile-bordered-img superscript-profile-bordered-img--mobile">
            <GatsbyImage
              alt={`${content.SUPERSCRIPT.tianah.name} with superscript teal border`}
              image={data.TianahHoddingBordered.childImageSharp.gatsbyImageData}
            />
          </div>
          <div className="superscript-section-2">
            <div className="superscript-section-2__text">
              <h3 className="superscript-margin-bottom--tiny">
                {content.SUPERSCRIPT.tianah.section2.header}
              </h3>
              <div>{content.SUPERSCRIPT.tianah.section2.text}</div>
            </div>
          </div>
          <div className="superscript-profile-bordered-img superscript-profile-bordered-img--desktop">
            <GatsbyImage
              alt={`${content.SUPERSCRIPT.tianah.name} with superscript teal border`}
              image={data.TianahHoddingBordered.childImageSharp.gatsbyImageData}
            />
          </div>
        </section>

        <section className="superscript-margin-bottom superscript-profile-reel">
          <GatsbyImage
            alt={`A reel of 4 photos of ${content.SUPERSCRIPT.tianah.name}`}
            className="superscript-profile-reel--desktop"
            image={data.TianahHoddingReelDesktop.childImageSharp.gatsbyImageData}
          />
          <GatsbyImage
            alt={`A reel of 4 photos of ${content.SUPERSCRIPT.tianah.name}`}
            className="superscript-profile-reel--mobile"
            image={data.TianahHoddingReelMobile.childImageSharp.gatsbyImageData}
          />
        </section>

        <section className="superscript-container superscript-margin-bottom">
          <div className="superscript-small-container">
            <div className="superscript-profile-summary">
              <h3 className="superscript-profile-summary__header">
                {content.SUPERSCRIPT.tianah.cta.header}
              </h3>
              {content.SUPERSCRIPT.tianah.cta.text}
            </div>
            <div className="superscript-profile-cta__bg">
              <p>{content.SUPERSCRIPT.tianah.cta.superscriptPromo}</p>
              <div className="superscript-profile-cta">
                Build your quote at&nbsp;
                <ExternalLink href="https://gosuperscript.com/?utm_source=courier_microsite&utm_medium=referral&utm_campaign=courier_microsite">
                  <strong>gosuperscript.com</strong>&nbsp;
                </ExternalLink>
                <ArrowRight color={COLORS.licorice} />
              </div>
            </div>
          </div>
        </section>

        <section className="superscript-margin-bottom">
          <h3 className="superscript-carousel-header">Read more</h3>
          <div className="supercript-profile-landing-cta">
            <Link to="/partnerships/superscript/">
              <ArrowLongLeft color={COLORS.licorice} /> Back to Flip the script
            </Link>
          </div>
          <SuperscriptCarousel data={content.SUPERSCRIPT.profileOverview} />
        </section>
      </div>
      <Footer />
    </div>
  );
};

export const query = graphql`{
  TianahHoddingHeader: file(
    relativePath: {eq: "assets/img/superscript/tianah-hodding-header.jpg"}
  ) {
    childImageSharp {
      gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
    }
  }
  TianahHoddingReelDesktop: file(
    relativePath: {eq: "assets/img/superscript/tianah-hodding-desktop-reel.jpg"}
  ) {
    childImageSharp {
      gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
    }
  }
  TianahHoddingReelMobile: file(
    relativePath: {eq: "assets/img/superscript/tianah-hodding-mobile-reel.jpg"}
  ) {
    childImageSharp {
      gatsbyImageData(
        width: 750
        quality: 100
        placeholder: NONE
        layout: CONSTRAINED
      )
    }
  }
  TianahHoddingBordered: file(
    relativePath: {eq: "assets/img/superscript/tianah-hodding-section-2.jpg"}
  ) {
    childImageSharp {
      gatsbyImageData(
        width: 600
        quality: 100
        placeholder: NONE
        layout: CONSTRAINED
      )
    }
  }
  SuperscriptStar: file(relativePath: {eq: "assets/svg/superscript/star.svg"}) {
    ...localSvg
  }
  QuoteLeft: file(relativePath: {eq: "assets/svg/superscript/left-quote.svg"}) {
    ...localSvg
  }
  QuoteRight: file(relativePath: {eq: "assets/svg/superscript/right-quote.svg"}) {
    ...localSvg
  }
}`;

SuperscriptTianahHodding.propTypes = {
  data: PropTypes.object,
};

export default SuperscriptTianahHodding;
